<overlay-scrollbars [options]="prodSettingsOptions" class="row row-m-20 product-setting-container-parent">
    <div id="product-setting-container" [formGroup]="formDataBinding" class="col-12 col-p-20 mt-4">
        <!-- CAROUSEL SETTINGS SECTION -->
        <section class="align-items-start justify-content-start pb-4">
            <div>
                <!-- LABEL -->
                <label class="section-title" cvLocalizedText langSection="MarketPlace_Management" langKey="Carousel_Settings">
                    Carousel Settings
                </label>
                <hr class="m-0">
                <!-- END LABEL -->
                <div class="justify-content-start mt-20-px">
                    <!-- CONTAINER INPUTS -->
                    <div class="d-block d-xs-block d-sm-block d-md-flex d-lg-flex">
                        <!-- INPUT CONTAINER -->
                        <div class="d-block w-100 pb-4">
                            <!-- CHECKBOX -->
                            <div class="d-flex mb-3">
                                <sol-checkbox type="checkbox" checkboxId="addToCarousel"
                                    [(ngModel)]="pspes.settingPointStoreProduct.Carousel"
                                    (ngModelChange)="checkboxChanged_showInCarousel()"
                                    [ngModelOptions]="{standalone: true}"
                                    >{{getLocalizationString('Add_To_Carousel', 'Add to carousel')}}</sol-checkbox>
                            </div>
                            <!-- /CHECKBOX -->
                            <div class="d-flex justify-content-between">
                                <!-- STARTDATE -->
                                <div class="stardDateContainerCarousel mr-3 w-50">
                                    <label class="col-form-label text-uppercase cxone-label-title-form-element">
                                        <span cvLocalizedText langSection="MarketPlace_Management"
                                            langKey="Start_Date_Summary">Start date</span>
                                    </label>
                                    <span class="required-sign"> *</span>
                                    <sol-date-picker mode="page" [(ngModel)]="carouselStart"
                                        datePickerId="dpCarouselStart"
                                        [disabled]="!pspes.settingPointStoreProduct.Carousel"
                                        (ngModelChange)="setCarouselStart($event)" [ngModelOptions]="{standalone: true}"
                                        [class]="validatorService.displayError(formDataBinding.controls['carouselStart']) ? 'error-selector' : 'no-selector'"
                                        datePickerContainer=".stardDateContainerCarousel">
                                    </sol-date-picker>
                                    <span class="error" *ngIf="validatorService.displayError(formDataBinding.controls['carouselStart'])">
                                        {{validatorService.getErrorMessage(formDataBinding.controls['carouselStart'])}}
                                    </span>
                                </div>
                                <!-- ENDDATE -->
                                <div class="endDateContainerCarousel w-50">
                                    <!-- END DATE LABEL -->
                                    <div class="d-inline">
                                        <label class="col-form-label text-uppercase cxone-label-title-form-element">
                                            <span cvLocalizedText langSection="MarketPlace_Management"
                                                langKey="End_Date_Summary">End date</span>
                                        </label>
                                        <div class="d-flex float-right pr-1">
                                            <sol-checkbox type="checkbox" checkboxId="endDateCarousel"
                                                [(ngModel)]="endDateCarousel"
                                                
                                                [ngModelOptions]="{standalone: true}"
                                                (ngModelChange)="checkboxChangedEndDateCarousel()"
                                                [disabled]="!pspes.settingPointStoreProduct.Carousel">{{getLocalizationString('No_End_Date', 'No end date')}}</sol-checkbox>
                                        </div>
                                    </div>
                                    <!-- /END DATE LABEL -->
                                    <sol-date-picker mode="page" [(ngModel)]="carouselEnd"
                                        datePickerId="dpCarouselEnd"
                                        [disabled]="!pspes.settingPointStoreProduct.Carousel || endDateCarousel"
                                        (ngModelChange)="setCarouselEnd($event)" [ngModelOptions]="{standalone: true}"
                                        [class]="validatorService.displayError(formDataBinding.controls['carouselEnd']) ? 'error-selector' : 'no-selector'"
                                        datePickerContainer=".endDateContainerCarousel">
                                    </sol-date-picker>
                                    <span class="error" *ngIf="validatorService.displayError(formDataBinding.controls['carouselEnd']) || validatorService.displayError(formDataBinding.controls['carouselDates'])">
                                        {{validatorService.getErrorMessage(formDataBinding.controls['carouselEnd']) ? validatorService.getErrorMessage(formDataBinding.controls['carouselEnd']) : validatorService.getErrorMessage(formDataBinding.controls['carouselDates'])}}
                                    </span>
                                </div>
                                <!-- /ENDDATE -->
                                <!-- /STARTDATE -->
                            </div>
                            <!-- /ENDDATE -->
                        </div>
                        <!-- DYNAMIC IMAGE -->
                        <div>
                            <img class="alternating-image pl-xl-5 pl-3 pr-0"
                                [src]=" pspes.settingPointStoreProduct.Carousel ? '../App_Themes/clearview-default/images/gamification/marketplace/cx-one-layout-options/Type=Carousel-On.png' : '../App_Themes/clearview-default/images/gamification/marketplace/cx-one-layout-options/Type=Carousel.png'">
                        </div>
                        <!-- /DYNAMIC IMAGE -->
                    </div>
                    <!-- /INPUTS -->
                </div>
            </div>
        </section>
        <!-- /CAROUSEL SETTINGS -->
        <!-- FEATURE SETTINGS SECTION -->
        <section class="align-items-start justify-content-start pb-4">
            <div>
                <!-- LABEL -->
                <label class="section-title" cvLocalizedText langSection="MarketPlace_Management" langKey="Featured_Settings">
                    Featured Settings
                </label>
                <hr class="m-0">
                <!-- END LABEL -->
                <div class="justify-content-start mt-20-px">
                    <!-- CONTAINER INPUTS -->
                    <div class="d-block d-xs-block d-sm-block d-md-flex d-lg-flex">
                        <!-- INPUT CONTAINER -->
                        <div class="d-block w-100 pb-3">
                            <!-- CHECKBOX -->
                            <div class="d-flex mb-3">
                                <sol-checkbox type="checkbox" checkboxId="addToFeature"
                                    [(ngModel)]="pspes.settingPointStoreProduct.FeaturedProduct"
                                    (ngModelChange)="checkboxChanged_showInFeatured()"
                                    [ngModelOptions]="{standalone: true}"
                                    >{{getLocalizationString('Add_Featured_Label', 'Add Featured label')}}</sol-checkbox>
                            </div>
                            <!-- /CHECKBOX -->
                            <div class="d-flex justify-content-between">
                                <!-- STARTDATE -->
                                <div class="startDateContainerFeature mr-3 w-50">
                                    <label class="col-form-label text-uppercase cxone-label-title-form-element">
                                        <span cvLocalizedText langSection="MarketPlace_Management"
                                            langKey="Start_Date_Summary">Start date</span>
                                    </label>
                                    <span class="required-sign"> *</span>
                                    <sol-date-picker mode="page" [(ngModel)]="featureStart"
                                        datePickerId="dpFeatureStart"
                                        (ngModelChange)="setFeatureStart($event)" [ngModelOptions]="{standalone: true}"
                                        [disabled]="!pspes.settingPointStoreProduct.FeaturedProduct"
                                        [class]="validatorService.displayError(formDataBinding.controls['featureStart']) ? 'error-selector' : 'no-selector'"
                                        datePickerContainer=".startDateContainerFeature">
                                    </sol-date-picker>
                                    <span class="error" *ngIf="validatorService.displayError(formDataBinding.controls['featureStart'])">
                                        {{validatorService.getErrorMessage(formDataBinding.controls['featureStart'])}}
                                    </span>
                                </div>
                                <!-- ENDDATE -->
                                <div class="endDateContainerFeature w-50">
                                    <!-- END DATE LABEL -->
                                    <div class="d-inline">
                                        <label class="col-form-label text-uppercase cxone-label-title-form-element">
                                            <span cvLocalizedText langSection="MarketPlace_Management"
                                                langKey="End_Date_Summary">End date</span>
                                        </label>
                                        <div class="d-flex float-right pr-1">
                                            <sol-checkbox type="checkbox" checkboxId="endDateFeature"
                                                [(ngModel)]="endDateFeaturedProduct"
                                                (ngModelChange)="checkboxChangedEndDateFeature()"
                                                [ngModelOptions]="{standalone: true}"
                                                [disabled]="!pspes.settingPointStoreProduct.FeaturedProduct"
                                                >{{getLocalizationString('No_End_Date', 'No end date')}}</sol-checkbox>
                                        </div>
                                    </div>
                                    <!-- /END DATE LABEL -->
                                    <sol-date-picker mode="page" [(ngModel)]="featureEnd"
                                        datePickerId="dpFeatureEnd"
                                        (ngModelChange)="setFeatureEnd($event)" [ngModelOptions]="{standalone: true}"
                                        [disabled]="!pspes.settingPointStoreProduct.FeaturedProduct || endDateFeaturedProduct"
                                        [class]="validatorService.displayError(formDataBinding.controls['featureEnd']) ? 'error-selector' : 'no-selector'"
                                        datePickerContainer=".endDateContainerFeature">
                                    </sol-date-picker>
                                    <span class="error" *ngIf="validatorService.displayError(formDataBinding.controls['featureEnd']) || validatorService.displayError(formDataBinding.controls['featureDates'])">
                                        {{validatorService.getErrorMessage(formDataBinding.controls['featureEnd']) ? validatorService.getErrorMessage(formDataBinding.controls['featureEnd']) : validatorService.getErrorMessage(formDataBinding.controls['featureDates'])}}
                                    </span>
                                </div>
                                <!-- /ENDDATE -->
                                <!-- /STARTDATE -->
                            </div>
                            <!-- /ENDDATE -->
                        </div>
                        <!-- DYNAMIC IMAGE -->
                        <div>
                            <img class="alternating-image pl-xl-5 pl-3 pr-0"
                                [src]="pspes.settingPointStoreProduct.FeaturedProduct ? '../App_Themes/clearview-default/images/gamification/marketplace/cx-one-layout-options/Type=Featured.png' :  '../App_Themes/clearview-default/images/gamification/marketplace/cx-one-layout-options/Type=Carousel.png'">
                        </div>
                        <!-- /DYNAMIC IMAGE -->
                    </div>
                    <!-- /INPUTS -->
                </div>
            </div>
        </section>
        <!-- /FEATURE SETTINGS -->
        <!-- DISCOUNT SETTINGS SECTION -->
        <section class="align-items-start justify-content-start pb-4">
            <div>
                <!-- LABEL -->
                <label class="section-title" cvLocalizedText langSection="MarketPlace_Management" langKey="Discount_Settings">
                    Discount Settings
                </label>
                <hr class="m-0">
                <!-- END LABEL -->
                <div class="justify-content-start mt-20-px">
                    <!-- CONTAINER INPUTS -->
                    <div class="d-block d-xs-block d-sm-block d-md-flex d-lg-flex">
                        <!-- INPUT CONTAINER -->
                        <div class="d-block w-100 pb-4">
                            <!-- CHECKBOX -->
                            <div class="d-flex mb-3">
                                <sol-checkbox type="checkbox" checkboxId="addDiscount"
                                    [(ngModel)]="pspes.settingPointStoreProduct.Sale"
                                    (ngModelChange)="checkboxChanged_showInOnSale()"
                                    [ngModelOptions]="{standalone: true}"
                                    >{{getLocalizationString('Add_Discount', 'Add discount')}}</sol-checkbox>
                            </div>
                            <!-- /CHECKBOX -->
                            <!-- CONDITIONAL DIV REGARDING VARIANTS -->
                            <div *ngIf="pspes.modifiedPointStoreProduct.HasProductVariations" class="pb-2">
                                <label class="col-form-label text-uppercase cxone-label-title-form-element">
                                    <span cvLocalizedText langSection="MarketPlace_Management"
                                        langKey="Variations_On_Sale">Variations on sale</span>
                                </label>
                                <sol-checkbox type="checkbox" checkboxId="allVariants"
                                    [disabled]="!pspes.settingPointStoreProduct.Sale"
                                    class="form-check-label font-size-14 color-theUpsideDown lato-bold"
                                    [(ngModel)]="selectAll" [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="checkAll()"
                                    >{{getLocalizationString('All_Variations', 'All Variations')}}</sol-checkbox>
                                <div class="d-flex"
                                    *ngFor="let variation of pspes.modifiedPointStoreProduct.VariationsData; let i = index">
                                    <sol-checkbox type="checkbox" [(ngModel)]="variation.VariationOnSale"
                                        [ngModelOptions]="{standalone: true}" id="vrnt-{{i}}"
                                        [disabled]="!pspes.settingPointStoreProduct.Sale"
                                        (ngModelChange)="checkboxChanged_VariationOnSale();">{{variation.VariationName}}</sol-checkbox>
                                </div>
                            </div>
                        <!-- /CONDITIONAL DIV REGARDING VARIANTS -->
                        <!-- PERCENTAGE -->
                        <div class="DateContainerFeature w-50 pb-2">
                            <label class="col-form-label text-uppercase cxone-label-title-form-element">
                                <span cvLocalizedText langSection="MarketPlace_Management"
                                    langKey="Percentage">Percentage</span>
                            </label>
                            <span class="required-sign"> *</span>
                            <sol-numeric-selector [(ngModel)]="percentageInput"
                                 id="percentage-numeric-selector"
                                (input)="setPercentageValue($event)" [ngModelOptions]="{standalone: true}"
                                (paste)="validateClipboardInput($event)"
                                (ngModelChange)="setPercentageValue($event)"
                                (keypress)="validateKeyboardInput($event)"
                                (focusout)="focusPercentageValue()" [step]="1" [min]="1" [max]="99"
                                [disabled]="!disabledPercentageValue || !pspes.settingPointStoreProduct.Sale"></sol-numeric-selector>
                            <!-- add ngmodel and ngModelChange, fill percentageInput -->
                            <span class="error" *ngIf="validatorService.displayError(formDataBinding.controls['percentageInput'])">
                                {{validatorService.getErrorMessage(formDataBinding.controls['percentageInput'])}}
                            </span>
                        </div>
                        <!-- /PERCENTAGE -->
                        <div class="d-flex justify-content-between">
                            <!-- STARTDATE -->
                            <div class="startDateContainerDiscount mr-3 w-50">
                                    <label class="col-form-label text-uppercase cxone-label-title-form-element">
                                        <span cvLocalizedText langSection="MarketPlace_Management"
                                            langKey="Start_Date_Summary">Start date</span>
                                    </label>
                                    <span class="required-sign"> *</span>
                                    <sol-date-picker mode="page" [(ngModel)]="saleStart" placement="top"
                                        datePickerId="dpSalesStart"
                                        [disabled]="!pspes.settingPointStoreProduct.Sale"
                                        (ngModelChange)="setSaleStart($event)" [ngModelOptions]="{standalone: true}"
                                        [class]="validatorService.displayError(formDataBinding.controls['saleStart']) ? 'error-selector' : 'no-selector'"
                                        datePickerContainer=".startDateContainerDiscount">
                                    </sol-date-picker>
                                    <span class="error" *ngIf="validatorService.displayError(formDataBinding.controls['saleStart'])">
                                        {{validatorService.getErrorMessage(formDataBinding.controls['saleStart'])}}
                                    </span>
                                </div>
                                <!-- ENDDATE -->
                                <div class="endDateContainerDiscount w-50">
                                    <!-- END DATE LABEL -->
                                    <div class="d-inline">
                                        <label class="col-form-label text-uppercase cxone-label-title-form-element">
                                            <span cvLocalizedText langSection="MarketPlace_Management"
                                                langKey="End_Date_Summary">End date</span>
                                        </label>
                                        <div class="d-flex float-right pr-1">
                                            <sol-checkbox type="checkbox" checkboxId="endDateSale"
                                                [(ngModel)]="endDateSale" (ngModelChange)="checkboxChangedEndDateSale()"
                                                [ngModelOptions]="{standalone: true}"
                                                [disabled]="!pspes.settingPointStoreProduct.Sale"
                                                >{{getLocalizationString('No_End_Date', 'No end date')}}</sol-checkbox>
                                        </div>
                                    </div>
                                    <!-- /END DATE LABEL -->
                                    <sol-date-picker mode="page" [(ngModel)]="saleEnd" placement="top"
                                        datePickerId="dpSalesEnd"
                                        (ngModelChange)="setSaleEnd($event)" [ngModelOptions]="{standalone: true}"
                                        [disabled]="!pspes.settingPointStoreProduct.Sale || endDateSale"
                                        [class]="validatorService.displayError(formDataBinding.controls['saleEnd']) ? 'error-selector' : 'no-selector'"
                                        datePickerContainer=".endDateContainerDiscount">
                                    </sol-date-picker>
                                    <span class="error" *ngIf="validatorService.displayError(formDataBinding.controls['saleEnd']) || validatorService.displayError(formDataBinding.controls['saleDates'])">
                                        {{validatorService.getErrorMessage(formDataBinding.controls['saleEnd']) ? validatorService.getErrorMessage(formDataBinding.controls['saleEnd']) : validatorService.getErrorMessage(formDataBinding.controls['saleDates'])}}
                                    </span>
                                </div>
                                <!-- /ENDDATE -->
                                <!-- /STARTDATE -->
                            </div>
                            <!-- /ENDDATE -->
                        </div>
                        <!-- DYNAMIC IMAGE -->
                        <div>
                            <img class="alternating-image pl-xl-5 pl-3 pr-0"
                                [src]="pspes.settingPointStoreProduct.Sale ? '../App_Themes/clearview-default/images/gamification/marketplace/cx-one-layout-options/Type=Discount-on.png': '../App_Themes/clearview-default/images/gamification/marketplace/cx-one-layout-options/Type=Discount.png'">
                        </div>
                        <!-- /DYNAMIC IMAGE -->
                    </div>
                    <!-- /INPUTS -->
                </div>
            </div>
        </section>
        <!-- /DISCOUNT SETTINGS -->
    </div>
</overlay-scrollbars>
